/**
 * 用於顯示右下角通知的 Vue 插件。
 * 此插件會在 Vue 的原型上安裝全域的 `$bottomRightToast` 方法，
 * 讓元件可以觸發通知訊息。
 *
 * @module bottomRightToast
 */
import Vue from 'vue'
import BottomRightToastContainer from '@/components/BottomRightToast/BottomRightToastContainer'
import router from '@/router'

/**
 * 安裝右下角通知插件。
 *
 * @property {Function} Vue.prototype.$bottomRightToast - 用於顯示通知訊息的方法。
 * @param {Object} options - 通知訊息的選項。
 * @param {string} options.title - 通知訊息的標題。
 * @param {string} options.content - 通知訊息的內容。
 * @param {string} [options.routeName] - 點擊訊息後 router.push 使用的路由名稱。
 * @param {Object} [options.routeParams] - 點擊訊息後 router.push 使用的 params。
 * @param {Object} [options.routeQuery] - 點擊訊息後 router.push 使用的 query。
 * @param {string} [options.href] - 點擊訊息後前往的外部或非 router 頁面。
 */
const ToastConstructor = Vue.extend(BottomRightToastContainer)
export default {
  install (Vue) {
    const instance = new ToastConstructor({ router })
    document.body.appendChild(instance.$mount().$el)
    Vue.prototype.$bottomRightToast = function ({ title, content, routeName, routeParams, routeQuery, href, iconClass }) {
      instance.addMessage({ title, content, routeName, routeParams, routeQuery, href, iconClass })
    }
  }
}
